import { SizingTool, SizingToolCreate } from '../models/sizing-tool.model';

export class SizingToolMapper {
  static mapToSizingToolCreate(sizingTool: SizingTool): SizingToolCreate {
    const { batteryRanges, ...rest } = sizingTool;

    const batteryRangesCreate: string[] = batteryRanges
      ? batteryRanges.map((batteryRange) => {
          return batteryRange.documentId ?? batteryRange.id;
        })
      : [];

    return {
      batteryRanges: batteryRangesCreate,
      ...rest,
    };
  }
}
